<ngx-stepper
  [steps]="steps()"
  [fullSize]="true"
  [orientation]="'vertical'"
  type="circle"
></ngx-stepper>
